import {StageLayer} from "@nolimit/slot-launcher/bin/StageLayer";
import {gsap, TweenLite, Power3} from "gsap";
import {Logger} from "@nolimit/slot-launcher/bin/utils/Logger";
import {BasicBitmapCountUp} from "../components/BasicBitmapCountUp";
import {FITH2Helper} from "../utils/FITH2Helper";
import {FITH2GameAssets} from "../FITH2GameAssets";
import {FireInTheHole2} from "../FireInTheHole2";
import {BitmapText} from "pixi.js";
import Spine = PIXI.spine.Spine;
import {FITH2SoundManager} from "../sound/FITH2SoundManager";
import {FITH2SoundConfig} from "../configs/FITH2SoundConfig";
import {TimelineSprite} from "@nolimit/slot-launcher/bin/animation/TimelineSprite";
import {NolimitApplication} from "@nolimit/slot-launcher/bin/NolimitApplication";
import {AnimationEffects} from "../components/ShakeEffect";

export class FITH2BigWinView extends PIXI.Container implements StageLayer {
    private _countUp: BasicBitmapCountUp;
    private _spines: PIXI.spine.Spine[];
    private _ghost: TimelineSprite;
    //private _title:PIXI.Sprite;
    private _waysNumber: BitmapText;
    private _waysText: PIXI.Sprite;
    private _maxLevel: number;

    constructor() {
        super();
        this.name = "BIG_WIN";
        this._spines = [];
        this.init();
    }

    public set maxLevel(value:number){
        this._maxLevel = value;
    }

    public onResize():void{
        this._ghost.position.y = NolimitApplication.screenBounds.bottom+50;
        FireInTheHole2.coinRain.onResize();
    }

    private init(): void {
        this._countUp = new BasicBitmapCountUp({
            fontName: FITH2GameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize: 54,
            tint: 0xffffff
        }, 660, new PIXI.Point(0.5, 0.5));
        this._countUp.position.set(360, 600);
        this._countUp.stopAt(0);

        this._ghost = new TimelineSprite(FireInTheHole2.assetLoader.getTextures("BigWin/BWFire/BW_Fire_"));
        this._ghost.anchor.set(0.5, 1);
        this._ghost.position.set(360, 0);
        this._ghost.blendMode = PIXI.BLEND_MODES.ADD;
        this._ghost.visible = false;

        //this._title = new PIXI.Sprite();
        //this._title.anchor.set(0.5, 0.5);
        //this._title.position.set(360,360);
        //this.addChild(this._title);
        this.addChild(this._countUp);

        this._waysNumber = new BitmapText("", {
            fontName: FITH2GameAssets.BITMAP_FONT_WIN_WAYS,
            fontSize: 40,
            tint: 0xffffff
        });
        this._waysNumber.letterSpacing = -12;
        this._waysText = new PIXI.Sprite();
        (<PIXI.Point>this._waysNumber.anchor).set(0, 1);
        this._waysText.anchor = new PIXI.Point(0, 0.7);

        this.visible = false;
        this.alpha = 0;
        this._countUp.visible = false;
        this.onResize();
    }

    public show(duration: number): gsap.core.Timeline {
        const tl = gsap.timeline();
        this.alpha = 0;
        this.visible = true;
        this._countUp.scale.set(0.5);
        this._countUp.position.set(360, 600);
        tl.add(()=>FireInTheHole2.coinRain.stopAll());
        tl.add(() => {
            FireInTheHole2.bigWinView._countUp.setAmount(0);
            gsap.to(this, {duration: duration, alpha: 1});
            FireInTheHole2.coinRain.stopAll();
            FireInTheHole2.coinRain.startBigWinRain(1);
        }, 0);
        const totalWinWays: number = FireInTheHole2.model.gameData.waysWonTotalRound;
        this._waysText.texture = FireInTheHole2.assetLoader.getTextures(`Way${totalWinWays > 1 ? "s" : ""}`)[0];
        this._waysNumber.text = totalWinWays.toString();
        const startPos: number = 360 - (this._waysNumber.width + this._waysText.width) * 0.5
        //this._waysNumber.position.set(startPos, 560);
        //this._waysText.position.set(startPos + this._waysNumber.width + 8, 560);
        //this._waysNumber.alpha = 0;
        //this._waysText.alpha = 0;
        //this.addChild(this._waysText, this._waysNumber);

        return tl;
    }

    public hide(duration: number = 0.0001): gsap.core.Timeline {
        const tl = gsap.timeline();
        tl.add(FireInTheHole2.gameViewContainer.removeDimmer(), 0.2);
        tl.add([
            gsap.to(this, {duration: duration, alpha: 0}),
            FireInTheHole2.coinRain.hide(duration)]);
        tl.add(() => {
            this.visible = false;
            this._countUp.visible = false;
            this._ghost.stopLoop();
            this._ghost.hide();
            this._spines.forEach((spine: Spine) => {
                spine.destroy();
            });
            FireInTheHole2.coinRain.stopAll();
            this._spines = [];
        });

        return tl;
    }

    private getSpine(level: number): Spine {
        let spine: Spine = new PIXI.spine.Spine(FireInTheHole2.assetLoader.getSpineAsset("bigWinLv" + level.toString()));
        spine.position.set(360, 360);
        spine.name = "BIGWIN_SPINE_LEVEL_" + level;
        this._spines.push(spine);
        spine.visible = false;
        return spine;
    }

    public getLevelAnimation(countFrom: number, countTo: number, duration: number, level: number): gsap.core.Timeline {
        Logger.logDev("getLevelAnimation called details :: from : " + countFrom + " to : " + countTo + " duration : " + duration + " level : " + level);
        const tl: gsap.core.Timeline = new gsap.core.Timeline(),
            spine: PIXI.spine.Spine = this.getSpine(level),
            isLastLevel:boolean = (level === this._maxLevel);

        tl.add(() => {
            if (level ===1) {
                this._ghost.playLoop();
            }
            this.addChild(this._ghost);
            //this._title.texture = FireInTheHole2.assetLoader.getTextures(`BigWin/BigWin_Title${level}`)[0];
            this.addChild(spine);
            //this.addChild(this._title);
            this.addChild(this._countUp);
            if (level > 1) {
                    this._spines[level - 2].visible = false;
                }
        });
        const scaleTl: gsap.core.Timeline = new gsap.core.Timeline(),
            delay: number = 0;
        scaleTl.add([
            ()=>{this.onBigWin(level);},
            this.getCountUpScaleAnimation(0.1, "power2.in", 0.4 + level * 0.1)
        ]);
        scaleTl.add(this.getCountUpScaleAnimation(0.2, "power2.out", 0.5 + (level + 1) * 0.1));
        scaleTl.add(this.getCountUpScaleAnimation(duration - 0.3, "power2.in", 0.5 + (level + 1) * 0.1));
        tl.add(() => {
            this._ghost.visible = true;
            spine.visible = true;
            this._ghost.scale.set(2, 0.5+0.2*level);
            spine.state.setAnimation(0, "eff_bg", true);
            spine.state.setAnimation(1, "eff_amount_bg", true);
            spine.state.setAnimation(2, "A", false);
        }, delay);
        tl.add(scaleTl, delay);
        if (level == 1) {
            tl.add(() => {
                this._countUp.visible = true;
            }, delay);
        }
        tl.add(this._countUp.getCountAnimation(countFrom, countTo, duration - 0.1, "none", level), delay + 0.1);
        tl.add(() => {
            FireInTheHole2.coinRain.stopAll();
            FireInTheHole2.coinRain.startBigWinRain(level);
        }, delay + level<5?0:1.7);
        if (isLastLevel) {
            tl.add([
                ()=>FITH2SoundManager.playBigWinEndSound(level-1),
                //TweenLite.to(this._waysNumber, 0.1, {alpha: 1}),
                //TweenLite.to(this._waysText, 0.1, {alpha: 1})
            ]);
        }

        return tl;
    }

    public onAbort(level: number): void {
        FITH2SoundManager.stopSoundEffect(FITH2SoundConfig.BIGWIN[level]);
    }

    public onBigWin(level:number): void {
        if(level === 5){
            return;
        }
        AnimationEffects.Shake({
            obj:this,
            duration: 0.5,
            hertz:160,
            x:1,
            y:1,
            Intensity:10+level*5,
            positionCb: () => new PIXI.Point(0,1+0.5*level),
            ease: Power3.easeOut,
            reverseEase:true
        })
    }
    private getCountUpScaleAnimation(duration: number, ease: string, to: number, from?: number): gsap.core.Timeline {
        const tl = gsap.timeline();
        if (from != undefined) {
            tl.add(() => {
                this._countUp.scale.set(from, from)
            });
        }
        tl.add(gsap.to(this._countUp.scale, {duration: duration, x: to, y: to, ease: ease}));
        return tl;
    }
}
